import {positionInTheArray} from '../../utils';

export const updateErrorList = (idsMultivanWithError, psrId, error) => {
  const elementInArray = positionInTheArray(idsMultivanWithError, psrId);

  if (elementInArray !== -1) {
    if (!error) {
      return idsMultivanWithError.filter((item) => item !== psrId);
    }

    return idsMultivanWithError;
  }

  if (error) {
    return [...idsMultivanWithError, psrId];
  }

  return idsMultivanWithError;
};
